import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "d-flex h-100 flex-column" }
const _hoisted_2 = { class: "side-menu-inner flex-fill overflow-auto" }
const _hoisted_3 = {
  key: 0,
  class: "side-menu-inner mt-2 pb-3 pr-2 pl-2",
  style: {"overflow":"initial !important"}
}

import {computed, provide} from "vue";
import ReactiveRequestLoader from "~/cabinet/vue/interface/data/ReactiveRequestLoader.vue";
import ReactiveRequest from "~/core-ui/ts/request/ReactiveRequest";
import DataProviderEntitySaveActionBlockForm
    from "~/cabinet/vue/client/events/action/types/dataProvider/entity/save/DataProviderEntitySaveActionBlockForm.vue";
import LcabApiRequestFactory from "~/cabinet/ts/api/LcabApiRequestFactory";
import {
    DataProviderEntitySaveActionDescription
} from "~/cabinet/ts/data/events/actionDescriptions/DataProvider/DataProviderEntitySaveActionDescription";
import {EventParamsByAuth} from "~/cabinet/vue/client/events/EventParamsByAuth";
import AbstractEntity, {AbstractEntityFields} from "~/ts/library/AbstractEntity";
import {
    DATA_PROVIDER_ENTITY_SAVE_MANUAL_FORM_ENTITY_ID_INJECTION_KEY,
    DATA_PROVIDER_ENTITY_SAVE_MANUAL_FORM_INJECTION_KEY
} from "~/cabinet/vue/client/events/action/types/dataProvider/entity/save/DataProviderEntitySaveActionParamInterface";
import SideMenuCard from "~/operatorApplication/vue/dialogs/dialog/sidemenu/SideMenuCard.vue";

interface TemplateResponseInterface {
    model: any;
}

import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "DataProviderEditEntityTab"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    entityTypeId: {},
    username: {},
    siteId: {},
    platformId: {},
    authPrimaryId: {},
    entityId: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

provide(DATA_PROVIDER_ENTITY_SAVE_MANUAL_FORM_INJECTION_KEY, true);
provide(DATA_PROVIDER_ENTITY_SAVE_MANUAL_FORM_ENTITY_ID_INJECTION_KEY, computed(() => props.entityId));

let request = computed(() => {
    return (new ReactiveRequest<Response>(
        LcabApiRequestFactory.create({
            url: "/api/events/dataProvider/operatorApplication/getEntityEditFormForOperatorApplication",
            p: {
                platformId: props.platformId,
                authPrimaryId: props.authPrimaryId,
                entityTypeId: props.entityTypeId,
                username: props.username,
                entityId: props.entityId,
                siteId: props.siteId
            }
        }, Response)
    )).setErrorCallback(() => emits('close'));
});

let selectedTemplate = computed(() => request.value.data?.templates.find(template => template.id == request.value.data.selectedTemplateId));

let templateRequest = computed(() => {
    let templateId = selectedTemplate.value?.id;
    if (templateId) {
        return (new ReactiveRequest<TemplateResponseInterface>(
            LcabApiRequestFactory.create({
                url: "/api/events/dataProvider/operatorApplication/getEntityEditFormForOperatorApplicationByTemplateId",
                p: {
                    platformId: props.platformId,
                    authPrimaryId: props.authPrimaryId,
                    entityTypeId: props.entityTypeId,
                    username: props.username,
                    entityId: props.entityId,
                    siteId: props.siteId,
                    templateId
                }
            })
        )).setErrorCallback(() => emits('close'));
    }
    return null;
});

async function saveEntity() {
    let result = await LcabApiRequestFactory.create({
        url: "/api/events/dataProvider/operatorApplication/saveEntityFromOperatorApplication",
        p: {
            platformId: props.platformId,
            authPrimaryId: props.authPrimaryId,
            entityTypeId: props.entityTypeId,
            username: props.username,
            entityId: props.entityId,
            siteId: props.siteId,
            model: templateRequest.value?.data?.model,
            templateId: selectedTemplate.value?.id
        }
    }).save();
    if (result.isSuccess) {
        emits('close');
    }
}
class Response extends AbstractEntity {
    actionDescription: DataProviderEntitySaveActionDescription;
    eventParamsByAuth: EventParamsByAuth;
    templates: {
        id: string,
        descr: string,
        model: any
    }[];
    selectedTemplateId: string;


    protected getFields(): AbstractEntityFields {
        return {
            actionDescription: DataProviderEntitySaveActionDescription,
            eventParamsByAuth: EventParamsByAuth
        };
    }
}


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ReactiveRequestLoader, { request: _unref(request) }, {
        default: _withCtx(() => [
          (_unref(request).data)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_unref(request).data.templates.length > 1)
                  ? (_openBlock(), _createBlock(SideMenuCard, {
                      key: 0,
                      collapsed: undefined
                    }, {
                      title: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                        _createTextVNode("Выберите шаблон", -1)
                      ]))]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(request).data.selectedTemplateId,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(request).data.selectedTemplateId) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(request).data.templates, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                value: item.id,
                                label: item.descr
                              }, null, 8, ["value", "label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(selectedTemplate))
                  ? (_openBlock(), _createBlock(ReactiveRequestLoader, {
                      key: 1,
                      request: _unref(templateRequest)
                    }, {
                      default: _withCtx(() => [
                        (_unref(templateRequest).data)
                          ? (_openBlock(), _createBlock(DataProviderEntitySaveActionBlockForm, {
                              key: _unref(selectedTemplate).id,
                              modelValue: _unref(templateRequest).data.model,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(templateRequest).data.model) = $event)),
                              "action-description": _unref(request).data.actionDescription,
                              "content-variables": [],
                              "event-params-by-auth": _unref(request).data.eventParamsByAuth,
                              "is-in-scheme": false
                            }, null, 8, ["modelValue", "action-description", "event-params-by-auth"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["request"]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["request"])
    ]),
    (_unref(selectedTemplate))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            class: "w-100",
            type: "primary",
            round: "",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (saveEntity()))
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("Сохранить", -1)
            ]))]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})